import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {Helmet} from 'react-helmet-async';

import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {TranslationKeys} from 'utils/constants/routeConstants';
import BackNav from 'components/back-nav';
import Privacy from 'components/privacy';

import './styles.scss';

export const PrivacyPolicy: React.FunctionComponent = () => {
  const intl = useIntl();

  useGetTranslations({
    translationKey: TranslationKeys.Footer
  });

  const title = intl.formatMessage({id: 'gritx.footer.links.privacy', defaultMessage: 'Privacy'});

  return <div className="privacy-policy-page">
    <Helmet>
      <title>{title} - Mira Now</title>
    </Helmet>
    <BackNav/>
    <div className="container">
      <Privacy/>
    </div>
    <footer className="privacy-policy-page__footer">
      <p>
        <FormattedMessage
          id={'gritx.footer.copyrightMira'}
          defaultMessage={'© {year} Scalable Care, a WSC Technology, Inc. company. All rights reserved.'}
          values={{year: new Date().getFullYear()}}
        />
      </p>
    </footer>
  </div>;
};
